import { useSelector } from 'react-redux';
import { estAdmin } from '../../lib/messagerie/droits';
import NotificationsMail from './NotificationsMail';
import BoutonMails from './BoutonMails';

/**
 * Pour un administrateur connecté, sur toutes les pages : les courriels qui
 * arrivent (en bas à droite) et le bouton des mails avec ses non lus (en bas à
 * gauche). Rien pour les autres visiteurs — aucune requête n'est faite.
 */
export default function MailsAdminGlobal() {
  const { isAuthenticated, user } = useSelector((s) => s.auth);
  if (!isAuthenticated || !estAdmin(user)) return null;

  return (
    <>
      <NotificationsMail />
      <BoutonMails />
    </>
  );
}
